import { useEffect } from "react";
import orderAPI from "../api/orderApi";
import { getSession, setSession, clearSession } from "../utils/sessionManager";
import { generateCartHash } from "../utils/cartHelper";
import PaymentService from "../pages/order/gateways/PaymentServices";
import { handleApiValidationError } from "../utils/apiErrorHandler";
import { showError } from "../utils/toastUtils";

export const useCheckout = (cartItems, formData) => {
  const initSession = async () => {
    const existing = getSession();
    const hash = generateCartHash(cartItems);

    if (
      existing &&
      existing.cartHash === hash &&
      new Date(existing.expiresAt) > new Date()
    ) {
      return existing;
    }

    try {
      const res = await orderAPI.createSession(formData);

      if (res.code === 200) {
        const result = res.data;

        const session = {
          sessionId: result.sessionId,
          expiresAt: result.expiresAt,
          cartHash: hash,
        };

        setSession(session);
        return session;
      }
    } catch (err) {
      handleApiValidationError(err, showError);
    }
  };

const placeOrder = async () => {
  const session = await initSession();

  const res = await orderAPI.placeOrder({
    sessionId: session.sessionId,
  });

  if (res.code === 200) {

    // COD order
    if (res.data.nextAction === "confirm") {
      clearSession();

      return {
        code: res.code,
        success: res.success,
        data: {
          ...res.data,
          type: "COD_SUCCESS",
        },
        message: res.message,
      };
    }

    // Razorpay / other payment
    if (
      res.data.nextAction === "pay" ||
      res.data.nextAction === "pay-advance"
    ) {
      return {
        code: res.code,
        success: res.success,
        data: res.data,
        message: res.message,
      };
    }
  }

  return res;
};

  // cart change → clear session
  useEffect(() => {
    clearSession();
  }, [cartItems]);

  return { placeOrder };
};
